import type { IScore } from '../../viewModels/gamification';

/**
 * Snapshot of the rep's pacing for the day. Source of truth for the top-bar
 * metrics strip and the milestone modal.
 *
 * Discriminated by `status` so the UI can branch between skeleton / loaded /
 * error without a separate "isLoading" boolean. The raw `score`/`goals`/
 * `projectedScore` are carried through so the metrics strip can derive the full
 * legacy tile set (see `deriveCoffeeMetrics`).
 */
export type DialPacingSnapshot =
	| { status: 'skeleton' }
	| { status: 'error'; message: string }
	| {
			status: 'loaded';
			dialsToday: number;
			/** Optional — null when the user has no goal configured. */
			dialGoal: number | null;
			connectsToday: number;
			demosBookedToday: number;
			pacePerHour: number;
			// Optional — userDailyActivity omits these for accounts with no goals
			// configured. Consumers normalize via deriveCoffeeMetrics.
			score?: IScore;
			goals?: IScore;
			projectedScore?: IScore;
			isSalesCoffee: boolean;
	  };

export function isLoadedSnapshot(
	snapshot: DialPacingSnapshot
): snapshot is Extract<DialPacingSnapshot, { status: 'loaded' }> {
	return snapshot.status === 'loaded';
}
